// extracted by mini-css-extract-plugin
export default {"train":"TrainIcon_train__ASHGm"};